import React, { useState, useEffect } from "react";
import { MenuOutlined } from "@ant-design/icons";
import Logo from "../Logo/Logo";
import LoggedInHeaderCategories from "../LoggedInHeaderCategories/LoggedInHeaderCategories";
import LoggedInUserInfo from "../LoggedInUserInfo/LoggedInUserInfo";
import MobileMenu from "../MobileMenu/MobileMenu";
import "./HeaderLoged.css";

function HeaderLoged({ setLoggedIn, profileImage, setProfileImage }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="header-container">
      <div className="header-section">
        <div className="header-logo-position">
          <Logo />
          <div className="header-categories">
            <LoggedInHeaderCategories />
          </div>
        </div>
        <div className="user-container">
          <LoggedInUserInfo 
            setLoggedIn={setLoggedIn} 
            profileImage={profileImage}
            setProfileImage={setProfileImage}
          />
        </div>
        <div className="burger-menu-icon" onClick={toggleMobileMenu}>
          <MenuOutlined />
        </div>
      </div>
      <MobileMenu 
        isOpen={isMobileMenuOpen} 
        onClose={() => setIsMobileMenuOpen(false)}
        isLoggedIn={true}
        setLoggedIn={setLoggedIn}
      />
    </div>
  );
}

export default HeaderLoged;